import { Injectable } from '@angular/core';
import { WorklistBaseService } from './base/worklist-base.service'; 

/** Il servizio WorklistService implementa le logiche client ed espone tutti i metodi del WorklistBaseService
 * che mappa il controller REST Workflow 1:1.
 * */
@Injectable({
    providedIn: 'root',
})
export class WorklistService extends WorklistBaseService {
    constructor() {
        super();
    }
}
